import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Eix from '../Eix/Eix'

import Eixos1 from '../../assets/img/Eix1.png'
import Eixos2 from '../../assets/img/Eix2.png'
import Eixos3 from '../../assets/img/Eix3.png'
import Eixos4 from '../../assets/img/Eix4.png'

import styles from './Eixos.module.css'

const Eix1 = ( props ) => {

    const [ data, setData ] = useState(null)
    const [ numberEix, setNumberEix ] = useState(null)
    const [ visible, setVisible ] = useState(false)

    useEffect(() => {
        setData(props.data)
        console.log(props.data)
        setNumberEix(props.number)
        setVisible(false)
    },[props.data, props.number])

    const handleOnChange = () => {
        setVisible(!visible)
    }

    const dataTitles = data && Object.keys(data)
    const dataTitlesValues = data && Object.values(data)

    const dataEixos = dataTitles && Object.values(dataTitlesValues[2])
    const nameEixos = dataEixos && dataEixos.map(element => element.titol)
    
    const objectiusEixos = dataEixos && dataEixos.map(element => element.elements)
    const objectiusEix1 = objectiusEixos && objectiusEixos[0]
    const objectiusEix2 = objectiusEixos && objectiusEixos[1]
    const objectiusEix3 = objectiusEixos && objectiusEixos[2]
    const objectiusEix4 = objectiusEixos && objectiusEixos[3]

    console.log("objectiusEixos", objectiusEix1)

    const titolsEix1 = objectiusEix1 && [objectiusEix1["504"].titol,objectiusEix1["505"].titol,objectiusEix1["506"].titol,objectiusEix1["507"].titol]
    const titolsEix2 = objectiusEix2 && [objectiusEix2["508"].titol,objectiusEix2["509"].titol,objectiusEix2["510"].titol,objectiusEix2["511"].titol]
    const titolsEix3 = objectiusEix3 && [objectiusEix3["512"].titol,objectiusEix3["513"].titol,objectiusEix3["514"].titol]
    const titolsEix4 = objectiusEix4 && [objectiusEix4["515"].titol,objectiusEix4["516"].titol,objectiusEix4["517"].titol]
    
    // Array de titols

    const titolsArray = [ titolsEix1, titolsEix2, titolsEix3, titolsEix4 ]

    const accionsEix1objetiu1 = objectiusEix1 && objectiusEix1["504"].accions
    const accionsEix1objetiu2 = objectiusEix1 && objectiusEix1["505"].accions
    const accionsEix1objetiu3 = objectiusEix1 && objectiusEix1["506"].accions
    const accionsEix1objetiu4 = objectiusEix1 && objectiusEix1["507"].accions
    const accionsEix2objetiu1 = objectiusEix2 && objectiusEix2["508"].accions
    const accionsEix2objetiu2 = objectiusEix2 && objectiusEix2["509"].accions
    const accionsEix2objetiu3 = objectiusEix2 && objectiusEix2["510"].accions
    const accionsEix2objetiu4 = objectiusEix2 && objectiusEix2["511"].accions
    const accionsEix3objetiu1 = objectiusEix3 && objectiusEix3["512"].accions
    const accionsEix3objetiu2 = objectiusEix3 && objectiusEix3["513"].accions
    const accionsEix3objetiu3 = objectiusEix3 && objectiusEix3["514"].accions
    const accionsEix4objetiu1 = objectiusEix4 && objectiusEix4["515"].accions
    const accionsEix4objetiu2 = objectiusEix4 && objectiusEix4["516"].accions
    const accionsEix4objetiu3 = objectiusEix4 && objectiusEix4["517"].accions

    // Array d'accions
    const accionsArrayEix1 = [accionsEix1objetiu1, accionsEix1objetiu2, accionsEix1objetiu3, accionsEix1objetiu4]
    const accionsArrayEix2 = [accionsEix2objetiu1, accionsEix2objetiu2, accionsEix2objetiu3, accionsEix2objetiu4]
    const accionsArrayEix3 = [accionsEix3objetiu1, accionsEix3objetiu2, accionsEix3objetiu3]
    const accionsArrayEix4 = [accionsEix4objetiu1, accionsEix4objetiu2, accionsEix4objetiu3]

    const accionsArray = [ accionsArrayEix1, accionsArrayEix2, accionsArrayEix3, accionsArrayEix4 ]

    // Mitjana de compliment accions Eix 1 - Objectiu 1
    const accionsEix11Compliment = accionsEix1objetiu1 && accionsEix1objetiu1.map(element => {
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })

    let number11 = accionsEix11Compliment && accionsEix11Compliment.length
    let total11 = accionsEix11Compliment && accionsEix11Compliment.reduce((a, b) => a + b, 0)
    let average11 = number11 && total11 && (total11/number11).toFixed(2)

    // Mitjana esperada de compliment accions Eix 1 - Objectiu 1
    const accionsEix11ComplimentEsperat = accionsEix1objetiu1 && accionsEix1objetiu1.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })

    let number11Esperat = accionsEix11ComplimentEsperat && accionsEix11ComplimentEsperat.length
    let total11Esperat = accionsEix11ComplimentEsperat && accionsEix11ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average11Esperat = number11Esperat && total11Esperat && (total11Esperat/number11Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 1 - Objectiu 2
    const accionsEix12Compliment = accionsEix1objetiu2 && accionsEix1objetiu2.map(element => {
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number12 = accionsEix12Compliment && accionsEix12Compliment.length
    let total12 = accionsEix12Compliment && accionsEix12Compliment.reduce((a, b) => a + b, 0)
    let average12 = number12 && total12 && (total12/number12).toFixed(2)

    // Mitjana esperada de compliment accions Eix 1 - Objectiu 2
    const accionsEix12ComplimentEsperat = accionsEix1objetiu2 && accionsEix1objetiu2.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number12Esperat = accionsEix12ComplimentEsperat && accionsEix12ComplimentEsperat.length
    let total12Esperat = accionsEix12ComplimentEsperat && accionsEix12ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average12Esperat = number12Esperat && total12Esperat && (total12Esperat/number12Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 1 - Objectiu 3
    const accionsEix13Compliment = accionsEix1objetiu3 && accionsEix1objetiu3.map(element => {
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number13 = accionsEix13Compliment && accionsEix13Compliment.length
    let total13 = accionsEix13Compliment && accionsEix13Compliment.reduce((a, b) => a + b, 0)
    let average13 = number13 && total13 && (total13/number13).toFixed(2)

    // Mitjana esperada de compliment accions Eix 1 - Objectiu 3
    const accionsEix13ComplimentEsperat = accionsEix1objetiu3 && accionsEix1objetiu3.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number13Esperat = accionsEix13ComplimentEsperat && accionsEix13ComplimentEsperat.length
    let total13Esperat = accionsEix13ComplimentEsperat && accionsEix13ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average13Esperat = number13Esperat && total13Esperat && (total13Esperat/number13Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 1 - Objectiu 4
    const accionsEix14Compliment = accionsEix1objetiu4 && accionsEix1objetiu4.map(element => {
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number14 = accionsEix14Compliment && accionsEix14Compliment.length
    let total14 = accionsEix14Compliment && accionsEix14Compliment.reduce((a, b) => a + b, 0)
    let average14 = number14 && total14 && (total14/number14).toFixed(2)

    // Mitjana esperada de compliment accions Eix 1 - Objectiu 4
    const accionsEix14ComplimentEsperat = accionsEix1objetiu4 && accionsEix1objetiu4.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number14Esperat = accionsEix14ComplimentEsperat && accionsEix14ComplimentEsperat.length
    let total14Esperat = accionsEix14ComplimentEsperat && accionsEix14ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average14Esperat = number14Esperat && total14Esperat && (total14Esperat/number14Esperat).toFixed(2)

    // Array mitjanes
    let averageArray1 = [average11, average12, average13, average14]

    // Array mitjanes esperades
    let averageArray1Esperat = [average11Esperat, average12Esperat, average13Esperat, average14Esperat]

    // Mitjana de compliment accions Eix 2 - Objectiu 1
    const accionsEix21Compliment = accionsEix2objetiu1 && accionsEix2objetiu1.map(element => {
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number21 = accionsEix21Compliment && accionsEix21Compliment.length
    let total21 = accionsEix21Compliment && accionsEix21Compliment.reduce((a, b) => a + b, 0)
    let average21 = number21 && total21 && (total21/number21).toFixed(2)

    // Mitjana esperada de compliment accions Eix 2 - Objectiu 1
    const accionsEix21ComplimentEsperat = accionsEix2objetiu1 && accionsEix2objetiu1.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number21Esperat = accionsEix21ComplimentEsperat && accionsEix21ComplimentEsperat.length
    let total21Esperat = accionsEix21ComplimentEsperat && accionsEix21ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average21Esperat = number21Esperat && total21Esperat && (total21Esperat/number21Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 2 - Objectiu 2
    const accionsEix22Compliment = accionsEix2objetiu2 && accionsEix2objetiu2.map(element => {
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number22 = accionsEix22Compliment && accionsEix22Compliment.length
    let total22 = accionsEix22Compliment && accionsEix22Compliment.reduce((a, b) => a + b, 0)
    let average22 = number22 && total22 && (total22/number22).toFixed(2)

    // Mitjana esperada de compliment accions Eix 2 - Objectiu 2
    const accionsEix22ComplimentEsperat = accionsEix2objetiu2 && accionsEix2objetiu2.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number22Esperat = accionsEix22ComplimentEsperat && accionsEix22ComplimentEsperat.length
    let total22Esperat = accionsEix22ComplimentEsperat && accionsEix22ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average22Esperat = number22Esperat && total22Esperat && (total22Esperat/number22Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 2 - Objectiu 3
    const accionsEix23Compliment = accionsEix2objetiu3 && accionsEix2objetiu3.map(element => {
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number23 = accionsEix23Compliment && accionsEix23Compliment.length
    let total23 = accionsEix23Compliment && accionsEix23Compliment.reduce((a, b) => a + b, 0)
    let average23 = number23 && total23 && (total23/number23).toFixed(2)

    // Mitjana esperada de compliment accions Eix 2 - Objectiu 3
    const accionsEix23ComplimentEsperat = accionsEix2objetiu3 && accionsEix2objetiu3.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number23Esperat = accionsEix23ComplimentEsperat && accionsEix23ComplimentEsperat.length
    let total23Esperat = accionsEix23ComplimentEsperat && accionsEix23ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average23Esperat = number23Esperat && total23Esperat && (total23Esperat/number23Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 2 - Objectiu 4
    const accionsEix24Compliment = accionsEix2objetiu4 && accionsEix2objetiu4.map(element => {
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number24 = accionsEix24Compliment && accionsEix24Compliment.length
    let total24 = accionsEix24Compliment && accionsEix24Compliment.reduce((a, b) => a + b, 0)
    let average24 = number24 && total24 && (total24/number24).toFixed(2)

    // Mitjana esperada de compliment accions Eix 2 - Objectiu 4
    const accionsEix24ComplimentEsperat = accionsEix2objetiu4 && accionsEix2objetiu4.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number24Esperat = accionsEix24ComplimentEsperat && accionsEix24ComplimentEsperat.length
    let total24Esperat = accionsEix24ComplimentEsperat && accionsEix24ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average24Esperat = number24Esperat && total24Esperat && (total24Esperat/number24Esperat).toFixed(2)
    
    // Array mitjanes
    let averageArray2 = [average21, average22, average23, average24]

    // Array mitjanes esperades
    let averageArray2Esperat = [average21Esperat, average22Esperat, average23Esperat, average24Esperat]

    // Mitjana de compliment accions Eix 3 - Objectiu 1
    const accionsEix31Compliment = accionsEix3objetiu1 && accionsEix3objetiu1.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number31 = accionsEix31Compliment && accionsEix31Compliment.length
    let total31 = accionsEix31Compliment && accionsEix31Compliment.reduce((a, b) => a + b, 0)
    let average31 = number31 && total31 && (total31/number31).toFixed(2)

    // Mitjana esperada de compliment accions Eix 3 - Objectiu 1
    const accionsEix31ComplimentEsperat = accionsEix3objetiu1 && accionsEix3objetiu1.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number31Esperat = accionsEix31ComplimentEsperat && accionsEix31ComplimentEsperat.length
    let total31Esperat = accionsEix31ComplimentEsperat && accionsEix31ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average31Esperat = number31Esperat && total31Esperat && (total31Esperat/number31Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 3 - Objectiu 2
    const accionsEix32Compliment = accionsEix3objetiu2 && accionsEix3objetiu2.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number32 = accionsEix32Compliment && accionsEix32Compliment.length
    let total32 = accionsEix32Compliment && accionsEix32Compliment.reduce((a, b) => a + b, 0)
    let average32 = number32 && total32 && (total32/number32).toFixed(2)

    // Mitjana esperada de compliment accions Eix 3 - Objectiu 2
    const accionsEix32ComplimentEsperat = accionsEix3objetiu2 && accionsEix3objetiu2.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number32Esperat = accionsEix32ComplimentEsperat && accionsEix32ComplimentEsperat.length
    let total32Esperat = accionsEix32ComplimentEsperat && accionsEix32ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average32Esperat = number32Esperat && total32Esperat && (total32Esperat/number32Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 3 - Objectiu 3
    const accionsEix33Compliment = accionsEix3objetiu3 && accionsEix3objetiu3.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number33 = accionsEix33Compliment && accionsEix33Compliment.length
    let total33 = accionsEix33Compliment && accionsEix33Compliment.reduce((a, b) => a + b, 0)
    let average33 = number33 && total33 && (total33/number33).toFixed(2)

    // Mitjana esperada de compliment accions Eix 3 - Objectiu 3
    const accionsEix33ComplimentEsperat = accionsEix3objetiu3 && accionsEix3objetiu3.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number33Esperat = accionsEix33ComplimentEsperat && accionsEix33ComplimentEsperat.length
    let total33Esperat = accionsEix33ComplimentEsperat && accionsEix33ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average33Esperat = number33Esperat && total33Esperat && (total33Esperat/number33Esperat).toFixed(2)

    // Array mitjanes
    let averageArray3 = [average31, average32, average33]

    // Array mitjanes esperades
    let averageArray3Esperat = [average31Esperat, average32Esperat, average33Esperat]

    // Mitjana de compliment accions Eix 4 - Objectiu 1
    const accionsEix41Compliment = accionsEix4objetiu1 && accionsEix4objetiu1.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number41 = accionsEix41Compliment && accionsEix41Compliment.length
    let total41 = accionsEix41Compliment && accionsEix41Compliment.reduce((a, b) => a + b, 0)
    let average41 = number41 && total41 && (total41/number41).toFixed(2)

    // Mitjana esperada de compliment accions Eix 4 - Objectiu 1
    const accionsEix41ComplimentEsperat = accionsEix4objetiu1 && accionsEix4objetiu1.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number41Esperat = accionsEix41ComplimentEsperat && accionsEix41ComplimentEsperat.length
    let total41Esperat = accionsEix41ComplimentEsperat && accionsEix41ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average41Esperat = number41Esperat && total41Esperat && (total41Esperat/number41Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 4 - Objectiu 2
    const accionsEix42Compliment = accionsEix4objetiu2 && accionsEix4objetiu2.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number42 = accionsEix42Compliment && accionsEix42Compliment.length
    let total42 = accionsEix42Compliment && accionsEix42Compliment.reduce((a, b) => a + b, 0)
    let average42 = number42 && total42 && (total42/number42).toFixed(2)

    // Mitjana esperada de compliment accions Eix 4 - Objectiu 2
    const accionsEix42ComplimentEsperat = accionsEix4objetiu2 && accionsEix4objetiu2.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number42Esperat = accionsEix42ComplimentEsperat && accionsEix42ComplimentEsperat.length
    let total42Esperat = accionsEix42ComplimentEsperat && accionsEix42ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average42Esperat = number42Esperat && total42Esperat && (total42Esperat/number42Esperat).toFixed(2)

    // Mitjana de compliment accions Eix 4 - Objectiu 3
    const accionsEix43Compliment = accionsEix4objetiu3 && accionsEix4objetiu3.map(element => {
        // return element && parseInt(element.valoracions[0].compliment)
        return element && parseInt(element.valoracions[(element.valoracions).length-1].compliment)
    })
    let number43 = accionsEix43Compliment && accionsEix43Compliment.length
    let total43 = accionsEix43Compliment && accionsEix43Compliment.reduce((a, b) => a + b, 0)
    let average43 = number43 && total43 && (total43/number43).toFixed(2)

    // Mitjana esperada de compliment accions Eix 4 - Objectiu 3
    const accionsEix43ComplimentEsperat = accionsEix4objetiu3 && accionsEix4objetiu3.map(element => {
        return element && parseInt(element.esperats[(element.esperats).length-1].compliment)
        // return element && parseInt(element.valoracions[0].compliment)
    })
    let number43Esperat = accionsEix43ComplimentEsperat && accionsEix43ComplimentEsperat.length
    let total43Esperat = accionsEix43ComplimentEsperat && accionsEix43ComplimentEsperat.reduce((a, b) => a + b, 0)
    let average43Esperat = number43Esperat && total43Esperat && (total43Esperat/number43Esperat).toFixed(2)

    // Array mitjanes
    let averageArray4 = [average41, average42, average43]

    // Array mitjanes esperades
    let averageArray4Esperat = [average41Esperat, average42Esperat, average43Esperat]

    // Array mitjana Eixs
    let average1 = parseFloat(average11) + parseFloat(average12) + parseFloat(average13) + parseFloat(average14)
    let average2 = parseFloat(average21) + parseFloat(average22) + parseFloat(average23) + parseFloat(average24)
    let average3 = parseFloat(average31) + parseFloat(average32) + parseFloat(average33)
    let average4 = parseFloat(average41) + parseFloat(average42) + parseFloat(average43)

    let averageArrays1 = [ parseFloat(average11), parseFloat(average12), parseFloat(average13), parseFloat(average14) ]
    let averageArrays2 = [ parseFloat(average21), parseFloat(average22), parseFloat(average23), parseFloat(average24) ]
    let averageArrays3 = [ parseFloat(average31), parseFloat(average32), parseFloat(average33) ]
    let averageArrays4 = [ parseFloat(average41), parseFloat(average42), parseFloat(average43) ]

    let averageTotal = [ averageArrays1, averageArrays2, averageArrays3, averageArrays4 ]

    let averageEixos = [
        (average1/4).toFixed(2),
        (average2/4).toFixed(2),
        (average3/3).toFixed(2),
        (average4/3).toFixed(2),
    ]

    // Array mitjana esperada Eixs
    let average1Esperat = parseFloat(average11Esperat) + parseFloat(average12Esperat) + parseFloat(average13Esperat) + parseFloat(average14Esperat)
    let average2Esperat = parseFloat(average21Esperat) + parseFloat(average22Esperat) + parseFloat(average23Esperat) + parseFloat(average24Esperat)
    let average3Esperat = parseFloat(average31Esperat) + parseFloat(average32Esperat) + parseFloat(average33Esperat)
    let average4Esperat = parseFloat(average41Esperat) + parseFloat(average42Esperat) + parseFloat(average43Esperat)

    let averageArrays1Esperat = [ parseFloat(average11Esperat), parseFloat(average12Esperat), parseFloat(average13Esperat), parseFloat(average14Esperat) ]
    let averageArrays2Esperat = [ parseFloat(average21Esperat), parseFloat(average22Esperat), parseFloat(average23Esperat), parseFloat(average24Esperat) ]
    let averageArrays3Esperat = [ parseFloat(average31Esperat), parseFloat(average32Esperat), parseFloat(average33Esperat) ]
    let averageArrays4Esperat = [ parseFloat(average41Esperat), parseFloat(average42Esperat), parseFloat(average43Esperat) ]

    let averageTotalEsperat = [ averageArrays1Esperat, averageArrays2Esperat, averageArrays3Esperat, averageArrays4Esperat ]

    let averageEixosEsperat = [
        (average1Esperat/4).toFixed(2),
        (average2Esperat/4).toFixed(2),
        (average3Esperat/3).toFixed(2),
        (average4Esperat/3).toFixed(2),
    ]

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.menu}>
                    <div className={`${styles.eix1} ${numberEix !== 0 && styles.eixGrey}`}>
                        <Link to={'/eixos/eix1'}><img src={Eixos1} alt='Eix1'/></Link>
                    </div>
                    <div className={`${styles.eix2} ${numberEix !== 1 && styles.eixGrey}`}>
                        <Link to={'/eixos/eix2'}><img src={Eixos2} alt='Eix2'/></Link>
                    </div>
                    <div className={`${styles.eix3} ${numberEix !== 2 && styles.eixGrey}`}>
                        <Link to={'/eixos/eix3'}><img src={Eixos3} alt='Eix3'/></Link>
                    </div>
                    <div className={`${styles.eix4} ${numberEix !== 3 && styles.eixGrey}`}>
                        <Link to={'/eixos/eix4'}><img src={Eixos4} alt='Eix4'/></Link>
                    </div>
                </div>
                <div className={styles.nameEix}>
                    <Eix name={nameEixos && nameEixos[numberEix && numberEix]} percentatge={averageEixos && averageEixos[numberEix && numberEix]} type={"h1"}></Eix>
                    <div className={styles.divEsperats2}>
                        <p className={styles.spanEsperats3}>{averageEixosEsperat[numberEix && numberEix]} %</p>
                    </div>
                </div>
            </div>
            <div>
                {
                    titolsArray[numberEix] && titolsArray[numberEix && numberEix].map((elementTitle, index) => {
                        return <>
                        <div className={styles.titles}>
                            <i className={visible === true ? "fa-solid fa-circle-arrow-up" : "fa-solid fa-circle-arrow-down"} onClick={handleOnChange}></i>
                            <h3><Eix name={elementTitle} percentatge={averageTotal[numberEix && numberEix][index]} type={"h3"}></Eix></h3>
                            <div className={styles.divEsperats2}>
                                <p className={styles.spanEsperats2}>{averageTotalEsperat[numberEix && numberEix][index]} %</p>
                            </div>
                        </div>
                        <table className={visible === true ? styles.tablesVisible : styles.tablesNoVisible}>
                            <tr>
                            <th>Acció</th>
                            <th>Responsable</th>
                            <th>Esforç</th>
                            <th>Impacte</th>
                            <th>Compliment</th>
                            </tr>
                            { 
                                index === 0 &&
                                accionsArray[numberEix][index] && accionsArray[numberEix][index].map(element => {
                                    const complimentEsperat = element.esperats[(element.esperats).length-1].compliment
                                    return (
                                        <tr>
                                            <td>{element.titol}</td>
                                            <td>{element.responsable}</td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].esforç}</p><p className={styles.spanEsperats}>{element.esperats[(element.esperats).length-1].esforç}</p></td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].impacte}</p><p className={styles.spanEsperats}>{element.esperats[(element.esperats).length-1].impacte}</p></td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].compliment}%</p><p className={styles.spanEsperats}>{complimentEsperat && parseInt(complimentEsperat, 10).toFixed(0)}%</p></td>
                                        </tr>
                                    )
                                })
                            }                  
                            { 
                                index === 1 &&
                                accionsArray[numberEix][index] && accionsArray[numberEix][index].map(element => {
                                    const complimentEsperat = element.esperats[(element.esperats).length-1].compliment
                                    return (
                                        <tr>
                                            <td>{element.titol}</td>
                                            <td>{element.responsable}</td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].esforç}</p><p className={styles.spanEsperats}>{element.esperats[(element.esperats).length-1].esforç}</p></td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].impacte}</p><p className={styles.spanEsperats}>{element.esperats[(element.esperats).length-1].impacte}</p></td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].compliment}%</p><p className={styles.spanEsperats}>{complimentEsperat && parseInt(complimentEsperat, 10).toFixed(0)}%</p></td>
                                        </tr>
                                    )
                                })
                            }
                            {
                                index === 2 &&
                                accionsArray[numberEix][index] && accionsArray[numberEix][index].map(element => {
                                    const complimentEsperat = element.esperats[(element.esperats).length-1].compliment
                                    return (
                                        <tr>
                                            <td>{element.titol}</td>
                                            <td>{element.responsable}</td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].esforç}</p><p className={styles.spanEsperats}>{element.esperats[(element.esperats).length-1].esforç}</p></td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].impacte}</p><p className={styles.spanEsperats}>{element.esperats[(element.esperats).length-1].impacte}</p></td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].compliment}%</p><p className={styles.spanEsperats}>{complimentEsperat && parseInt(complimentEsperat, 10).toFixed(0)}%</p></td>
                                        </tr>
                                    )
                                })
                            }
                            {
                                index === 3 &&
                                accionsArray[numberEix][index] && accionsArray[numberEix][index].map(element => {
                                    const complimentEsperat = element.esperats[(element.esperats).length-1].compliment
                                    return (
                                        <tr >
                                            <td>{element.titol}</td>
                                            <td>{element.responsable}</td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].esforç}</p><p className={styles.spanEsperats}>{element.esperats[(element.esperats).length-1].esforç}</p></td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].impacte}</p><p className={styles.spanEsperats}>{element.esperats[(element.esperats).length-1].impacte}</p></td>
                                            <td className={styles.celaSpan}><p className={styles.pSpan}>{element.valoracions[(element.valoracions).length-1].compliment}%</p><p className={styles.spanEsperats}>{complimentEsperat && parseInt(complimentEsperat, 10).toFixed(0)}%</p></td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                    </>
                    })
                }
            </div>
        </div>
    )
}

export default Eix1 